import DEFINES from '@/defines';
// GUEST
import Homepage from '@/pages/guest/Home';

// COMPANY
import CompanyAbout from '@/pages/company/About';
import CompanyPrivacy from '@/pages/company/Privacy';
import CompanyTerms from '@/pages/company/Terms';

// SCREENER
import ScreenerRoot from '@/pages/screener/Root';
import ScreenerToday from '@/pages/screener/Today';
import ScreenerUpcoming from '@/pages/screener/Upcoming';
import ScreenerOngoing from '@/pages/screener/Ongoing';
import ScreenerArchive from '@/pages/screener/Archive';

// Not Found Page
import PageNotFound from '@/pages/PageNotFound';

//VOD MOVIES
import VodMovies from '@/pages/vod/VodMovies';


export default [
  {
    path: '/',
    name: 'home',
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
      public: true,
    },
    component: Homepage,
  },
  {
    path: '/about',
    name: 'company.about',
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
      public: true,
    },
    component: CompanyAbout,
  },
  {
    path: '/privacy',
    name: 'company.privacy',
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
      public: true,
    },
    component: CompanyPrivacy,
  },
  {
    path: '/terms',
    name: 'company.terms',
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
      public: true,
    },
    component: CompanyTerms,
  },

  // /* Screeners */
  {
    path: '/screeners',
    name: 'screeners',
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
    },
    component: ScreenerRoot,
    children: [
      {
        path: 'today',
        name: 'screeners.today',
        meta: {
          layout: DEFINES.LAYOUT_GUEST,
          public: true,
        },
        component: ScreenerToday,
      },
      {
        path: 'upcoming',
        name: 'screeners.upcoming',
        meta: {
          layout: DEFINES.LAYOUT_GUEST,
          public: true,
        },
        component: ScreenerUpcoming,
      },
      {
        path: 'ongoing',
        name: 'screeners.ongoing',
        meta: {
          layout: DEFINES.LAYOUT_GUEST,
          public: true,
        },
        component: ScreenerOngoing,
      },
      {
        path: 'archive',
        name: 'screeners.archive',
        meta: {
          layout: DEFINES.LAYOUT_GUEST,
          public: true,
        },
        component: ScreenerArchive,
      }
    ]
  },

  {
    path: '/vod/movies',
    name: 'vod.movies',
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
      public: true,
    },
    component: VodMovies,
  },
  {
    path: '/*',
    name: 'abort',
    component: PageNotFound,
    meta: {
      layout: DEFINES.LAYOUT_GUEST,
    },
  },
];
